module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_round__oval.22c95b48.png";